import xhr from 'xhr';

export default async function getStudent(data) {
  const res2 = await xhr(`/students/${data.student}?populate=*`);
  return res2.data.data;
}
